import { createContext, useContext } from "react";
import type { Posture } from "@/lib/api";

export type Suggestions = {
  orgName: string | null;
  orgWebsite: string | null;
  agentName: string | null;
  orgInfo: string | null;
};

export type PreviewState = {
  orgName: string;
  orgWebsite: string;
  agentName: string;
  orgInfo: string;
  // Which onboarding branch renders. Seeded from the entry-path intent, then
  // overwritten by /api/onboarding/state once the container row exists.
  posture: Posture;
  // Chief-of-staff setup inputs, sent with the container create and confirmed
  // (not re-asked) by the brain's setup interview.
  timeZone: string;
  briefingTime: string;
  // The website the initial (email-domain) suggestions call provided,
  // if any — lets the org step tell "user typed a new URL" apart from
  // "the pre-filled URL echoed through the debounce".
  suggestedWebsite: string | null;
  setOrgName: (name: string) => void;
  setOrgWebsite: (url: string) => void;
  setAgentName: (name: string) => void;
  setOrgInfo: (info: string) => void;
  setPosture: (p: Posture) => void;
  setTimeZone: (tz: string) => void;
  setBriefingTime: (t: string) => void;
  applySuggestions: (s: Suggestions) => void;
};

export const PreviewContext = createContext<PreviewState | null>(null);

export function usePreview() {
  const ctx = useContext(PreviewContext);
  if (!ctx) throw new Error("usePreview must be used inside PreviewProvider");
  return ctx;
}
